import React from 'react';
import PropTypes from 'prop-types';
import {
    VALID_DOCUMENT_TYPES_FOR_IMAGE_CONTENT,
    VALID_DOCUMENT_TYPES_FOR_ACCEPTED_DOCUMENTS_CONTENT,
} from '../../../constants';
import { imageContentMap } from '../../../contentMaps';
import { ModalWithAcceptedDocumentsContent } from '../ModalWithAcceptedDocumentsContent';
import { ModalWithImageContent } from '../ModalWithImageContent';

export const buildModalContentbyType = (documentType, accountType, profession) => {
    if (VALID_DOCUMENT_TYPES_FOR_IMAGE_CONTENT.includes(documentType)) {
        return <ModalWithImageContent {...imageContentMap[documentType]} />;
    }

    if (VALID_DOCUMENT_TYPES_FOR_ACCEPTED_DOCUMENTS_CONTENT.includes(documentType)) {
        return (
            <ModalWithAcceptedDocumentsContent
                documentType={documentType}
                accountType={accountType}
                profession={profession}
            />
        );
    }

    return null;
};

ModalWithImageContent.propTypes = {
    image: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
};
